/**
 * This file was auto-generated by @gonfalon/openapi/generate.ts.
 * Do not make direct changes to the file.
 *
 * If you have any questions, reach out to #ask-frontend.
 */

import { mergeHeaders } from 'openapi-fetch';
import { type OperationRequestBodyContent } from 'openapi-typescript-helpers';
import { getClient } from '../../internal/client';
import type { operations } from '../openapi';

export type PatchPlaygroundPathParams = NonNullable<operations['patchPlayground']['parameters']['path']>;

export type PatchPlaygroundRequestBody = OperationRequestBodyContent<operations['patchPlayground']>;

export interface Input extends PatchPlaygroundPathParams {
  apiVersion?: string;
  body: PatchPlaygroundRequestBody;
}

export async function patchPlayground(
  { apiVersion, body, ...path }: Input,
  { headers, signal }: { headers?: HeadersInit; signal?: AbortSignal } = {},
) {
  return getClient().PATCH('/internal/projects/{projKey}/playgrounds/{playgroundId}', {
    params: { path },
    body,
    headers: apiVersion ? mergeHeaders(headers, { 'LD-API-Version': apiVersion }) : headers,
    signal,
  });
}
